angular.module('mtic.components.modules').service('MapDataMassage', function($log) {

      var TEMP_UNLOCK_CORE = [
        // 'mtic_g78_m2_equiv_expr',
        // 'mtic_g78_m2_grand_stair_pt1',
        // 'mtic_g78_m2_prog_calc_a',
        // 'mtic_g78_m2_spread_calc_pt1',
        // 'mtic_g78_m2_dist_act',
        // 'mtic_g78_m1_beaker',
        // 'mtic_g78_m1_prop_table_a'
      ]

  return {
    getTempUnlocks: function(){
      return TEMP_UNLOCK_CORE;
    },

    massageResourceMapOne: function(resourceMap) {
      var newChildrenList = [];
      var item;

      var disabled_items = [
        //'mtic_g78_m1_candy',
        //'mtic_g78_m1_robot',
        //'mtic_g78_m1_juice',
        //'mtic_g78_m1_crepes',
        //'mtic_g78_m1_meeting',
        //'mtic_g78_m1_path',
        //'mtic_g78_m1_open',
        // 'mtic_g78_m1_summ',
        //'mtic_g78_m1_flooring',
        // 'mtic_g78_m1_diag',
        //'mtic_g78_m1_analyze_coef'
      ]
      var i, n, j;

      for (i = 0; i < resourceMap.length; i++) {
        item = resourceMap[i];
        if (TEMP_UNLOCK_CORE) {
          if (_.indexOf(TEMP_UNLOCK_CORE, item.slug) !== -1) {
            item.locked = false;
          }
        }

        if (item.slug === 'mtic_g78_m1_prop_table_a') {
          item.unlocked_by = ['mtic_g78_m1_diag'];
        }

        if (item.resource_type === 'symlink') {
          item.complete = true;
          for (n = 0; n < item.unlocked_by.length; n++) {
            for (j = 0; j < resourceMap.length; j++) {
              if (item.unlocked_by[n] === resourceMap[j].slug) {
                item.complete = item.complete && resourceMap[j].complete;
              }
            }
          }
        }
        if (disabled_items.indexOf(item.slug) === -1) {
          newChildrenList.push(item);
        }
      }

      //we need to do this check because the db isn't accounting for symlinks yet
      //Standard LOOP over the entire map, checking if any items are locked and if they should be unlocked (all unlocked_by are COMPLETE)
      //repeat the entire loop if any  new items were unlocked in the last loop
      var check_again = true;
      var unlock = true;
      while (check_again) {
        check_again = false;
        for (i = 0; i < newChildrenList.length; i++) {
          item = newChildrenList[i];
          if (item.locked === false) {
            continue;
          }
          unlock = true;
          for (n = 0; n < item.unlocked_by.length; n++) {
            for (j = 0; j < newChildrenList.length; j++) {
              if (item.unlocked_by[n] === newChildrenList[j].slug) {
                unlock = unlock && newChildrenList[j].complete;
              }
            }
          }
          if (unlock && (!item.config || !item.config.assessment_type)) {
            item.locked = false;
            check_again = true;
          }
        }
      }
      return newChildrenList;
    },
    massageResourceMapTwo: function(resourceMap) {

      var newChildrenList = [];

      //Make our MapItem templates for the groups
      var dist_add_group = {
        children: [],
        id: -1,
        name: "Simple Distributivity (Addition)",
        slug: "mtic_g78_m2_distrib_add_group",
        unlocked_by: [],
        display: {
          position: {},
          color: "blue"
        },
        config: {},
        content: {},
        resource_type: "group"
      }
      var dist_sub_group = {
        children: [],
        id: -1,
        name: "Simple Distributivity (Subtraction)",
        slug: "mtic_g78_m2_distrib_sub_group",
        unlocked_by: ['mtic_g78_m2_distrib_add_group',
          'mtic_g78_m2_distrib_add_pt3'
        ],
        display: {
          position: {},
          color: "blue"
        },
        config: {},
        content: {},
        resource_type: "group"
      }

      var spread_calc_group = {
        children: [],
        id: -1,
        name: "Spreadsheet and Calculation Programs",
        slug: "mtic_g78_m2_spread_calc_group",
        unlocked_by: [],
        display: {
          position: {},
          color: "blue"
        },
        config: {},
        content: {},
        resource_type: "group"
      }

      var factoring_group = {
          children: [],
          id: -1,
          name: "Factoring",
          slug: "mtic_g78_m2_factoring_group",
          unlocked_by: ['mtic_g78_m2_distrib_add_group',
            'mtic_g78_m2_distrib_add_pt3'
          ],
          display: {
            position: {},
            color: "blue"
          },
          config: {},
          content: {},
          resource_type: "group"
        }
        //   newChildrenList.push(dist_add_group);
        //   newChildrenList.push(dist_sub_group);
        //   newChildrenList.push(spread_calc_group);
        //   newChildrenList.push(factoring_group);

      //Add the map items that should be in the groups to the groups, and put the rest in the root group
      _.forEach(resourceMap, function(someItem) {

        if (TEMP_UNLOCK_CORE) {
          if (_.indexOf(TEMP_UNLOCK_CORE, someItem.slug) !== -1) {
            someItem.locked = false;
          }
        }

        switch (someItem.slug) {
            //fix up other stuff
          case "mtic_g78_m2_factoring_ex":
            someItem.unlocked_by.push('mtic_g78_m2_factoring_group');
            newChildrenList.push(someItem);
            break;
          case "mtic_g78_m2_fibonacci":
            someItem.unlocked_by.push('mtic_g78_m2_distrib_sub_group');
            newChildrenList.push(someItem);
            break;
          case "mtic_g78_m2_distrib_exer":
            someItem.unlocked_by.push('mtic_g78_m2_distrib_sub_group');
            newChildrenList.push(someItem);
            break;
          case "mtic_g78_m2_sum":
            someItem.unlocked_by = [];
            break;
          default:
            newChildrenList.push(someItem);
            break;
        }
      });

      //Check for group completions
      //Are all of the children of the group finished?
      _.forEach(newChildrenList, function(someItem) {
        if (someItem.children && someItem.children.length > 0) {
          var doComplete = true;
          for (var n = 0; n < someItem.children.length; n++) {
            if (!someItem.children[n].complete) {
              doComplete = false;
            }
          }
          if (doComplete) {
            someItem.studentWork = [];
            someItem.complete = true;
          }
        }
      });


      return newChildrenList;
    }
  }
})
